import ApiService from "@/common/api/api.service";

let endpoint = "Proposta";

const CronogramaFinanceiro = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },
    
    buscar(id) {
        return ApiService.get(`${endpoint}/cronograma-financeiro?propostaId=${id}`);
    },
        
    salvar(form) {
        if(form.cronogramaFinanceiroId){
            return ApiService.put(`${endpoint}/cronograma-financeiro`, form);
        }else{
            return ApiService.post(`${endpoint}/cronograma-financeiro`, form);
        }
    },

    deletar(form) {
        return ApiService.delete(`${endpoint}/cronograma-financeiro`, form);
    },

    getEmpresas(id) {
        return ApiService.get(`${endpoint}/cronograma-financeiro-empresas?propostaId=${id}`);
    }
}

export default CronogramaFinanceiro;